const onlyLicencePlate = value =>
  /^([a-zA-Z]{1,2}|[a-zA-Z]{2}\d{1,3}|[a-zA-Z]{2}\d{3}[a-zA-Z]{1,2}|[a-zA-Z]{1,3}|[a-zA-Z]{3}\d{1}|[a-zA-Z]{3}\d{1}[a-zA-z]{1}|[a-zA-Z]{3}\d{1}[a-zA-z]{1}\d{1,2}|[a-zA-Z]{1,4}|[a-zA-Z]{4}\d{1,3}|[a-zA-Z]{3}|[a-zA-Z]{3}\d{1,4})$/g.test(
    value
  ) || value === '';

export default onlyLicencePlate;
